<template>
  <div>
    <b-container>
      <LoadingSpinner :loading="loading" />
      <PdfContainer
        @onProgress="onProgress"
        :generatePdf="generatePdf"
        :paginateElementsByHeight="1100"
      >
        <template slot="content">
          <b-row v-if="!loading && hasData" align-h="center" align-v="center">
            <b-col cols="12" md="12" class="mt-0">
              <div class="first-page section">
                <b-img :src="logo" class="first-page__logo" width="200" />
                <span class="first-page__title">{{ reportCaption }}</span>
                <b-row class="first-page__footer">
                  <b-col
                    v-if="reportExecuteName"
                    class="first-page__footer-item"
                    v-text="
                      `کد و نام مشارکت کننده: ${reportExecuteCode} - ${reportExecuteName}`
                    "
                  />
                  <b-col
                    v-else
                    class="first-page__footer-item"
                    v-text="`کد مشارکت کننده: ${reportExecuteCode}`"
                  />
                  <b-col
                    class="first-page__footer-item"
                    v-text="`تاریخ: ${reportDateJalali}`"
                  />
                </b-row>
              </div>
            </b-col>
            <b-col cols="12" md="12" class="page_break" />
            <b-col cols="12" md="12" class="mt-3">
              <b-container>
                <b-row>
                  <b-col class="px-0">
                    <div class="second-page position-relative section">
                      <div class="second-page__title">
                        <div class="second-page__title-top mb-5">
                          <span>{{ reportCaption }}</span>
                          <span class="ml-4" v-text="reportDateJalali" />
                        </div>
                        <div class="second-page__title-bottom text-right">
                          <span
                            v-if="reportExecuteName"
                            v-text="
                              `${reportExecuteCode} - ${reportExecuteName}`
                            "
                          />
                          <span v-else v-text="reportExecuteCode" />
                        </div>
                      </div>
                      <div class="second-page__content">
                        <b-container class="p-md-5">
                          <b-row class="px-md-5">
                            <b-col
                              cols="12"
                              md="12"
                              class="header-bar p-2 mb-3 mt-200"
                              v-text="'نمای کلی شایستگی‌های مورد ارزیابی'"
                            />
                            <b-col>
                              <table
                                stickycolumn="true"
                                role="table"
                                class="washup-table table table-bordered text-center bg_white"
                              >
                                <thead role="rowgroup" class="text-center">
                                  <tr role="row">
                                    <th
                                      class="bg-blue-light text-dark text-center"
                                      style="width: 25%"
                                    >
                                      <strong v-text="$lang.competency" /> /
                                      <strong v-text="$lang.exercise" />
                                    </th>
                                    <th
                                      class="text-center text-dark align-middle bg-blue-light"
                                      v-for="(
                                        exercise, exerciseIndex
                                      ) in exercises"
                                      :key="exerciseIndex"
                                      :style="
                                        exerciseIndex === exercises.length - 1
                                          ? 'width: 7%;'
                                          : `width: ${
                                              68 / exercises.length - 1
                                            }%`
                                      "
                                      role="columnheader"
                                      scope="col"
                                    >
                                      <strong
                                        v-text="
                                          pathOr(null, ['name'], exercise)
                                        "
                                      />
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(
                                      competency, competencyIndex
                                    ) in competencies"
                                    :key="competencyIndex"
                                  >
                                    <td
                                      class="text-left text-dark bg-blue-light"
                                    >
                                      <strong
                                        class="ml-2"
                                        v-text="
                                          pathOr(null, ['name'], competency)
                                        "
                                      />
                                    </td>
                                    <template
                                      v-for="(
                                        exercise, exerciseIndex
                                      ) in competency.exercise"
                                    >
                                      <td
                                        :key="exerciseIndex"
                                        class="align-middle font-weight-bold"
                                        :class="
                                          generateTdColor(
                                            pathOr('', ['score'], exercise)
                                          )
                                        "
                                        v-text="pathOr('', ['score'], exercise)"
                                      />
                                    </template>
                                  </tr>
                                </tbody>
                              </table>
                            </b-col>
                          </b-row>
                          <b-row class="px-md-5">
                            <b-col
                              cols="12"
                              md="12"
                              class="header-bar p-2 mb-3"
                              v-text="'امید به عملکرد موفق'"
                            />
                            <b-col cols="12" md="6">
                              <PercentTable :data="minData" />
                            </b-col>
                            <b-col cols="12" md="6">
                              <PercentTable :data="maxData" />
                            </b-col>
                            <b-col
                              cols="12"
                              md="12"
                              v-text="minMaxText"
                              class="mb-3"
                            />
                            <b-col cols="12" md="12">
                              <PercentTable :data="forecastData" />
                            </b-col>
                            <b-col cols="12" md="12">
                              <PercentTable :data="overallData" />
                            </b-col>
                          </b-row>
                          <div class="page_break" />
                          <b-row class="px-md-5">
                            <b-col
                              cols="12"
                              md="12"
                              class="header-bar p-2 mb-3"
                              v-text="'اثر موقعیت بر موفقیت'"
                            />
                            <b-col
                              v-for="(
                                row, index
                              ) of effect_of_position_on_success"
                              :key="index"
                              cols="12"
                              md="6"
                            >
                              <PercentTable :data="row" />
                            </b-col>
                          </b-row>
                        </b-container>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
            <b-col cols="12" md="12" class="text-center border-top pt-4">
              <b-button
                class="mx-2"
                variant="primary"
                v-text="$lang.report_print"
                @click="print"
              />
            </b-col>
          </b-row>
          <b-row v-if="!loading && !hasData">
            <b-col
              class="bg-light p-3 text-center rounded"
              v-text="$lang.notRecordExist"
            />
          </b-row>
        </template>
      </PdfContainer>
    </b-container>
  </div>
</template>
<script>
import PercentTable from "./components/PercentTable";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import exportPdf from "@/components/base/exportPdf";

export default {
  name: "analytical-report",
  components: {
    PercentTable,
    LoadingSpinner,
    PdfContainer: exportPdf,
  },
  data() {
    return {
      loading: false,
      hasData: false,
      competencies: [],
      exercises: [],
      hope_to_successful_performance: null,
      effect_of_position_on_success: [],
      reportData: null,
      resourceCode: this.$route.params.resourceCode,
      parvandehCode: this.$route.params.parvandehCode,
      generatePdf: false,
      logo: this.$config.images.tinyLogo,
    };
  },
  computed: {
    minMaxText() {
      const rateOne = pathOr(
        null,
        ["min", "efficiency"],
        this.hope_to_successful_performance
      );
      const rateTwo = pathOr(
        null,
        ["max", "efficiency"],
        this.hope_to_successful_performance
      );
      return `با در نظرگرفتن حداقل نمرات در هر شایستگی می توان عملکرد این فرد را ${rateOne} درصد پیش بینی نمود و در صورتی که حداکثر نمره در هر شایستگی لحاظ شود بازده انتظاری از عملکرد ایشان ${rateTwo} درصد می باشد.`;
    },
    minData() {
      return pathOr(null, ["min"], this.hope_to_successful_performance);
    },
    maxData() {
      return pathOr(null, ["max"], this.hope_to_successful_performance);
    },
    forecastData() {
      return pathOr(null, ["forecast"], this.hope_to_successful_performance);
    },
    overallData() {
      return pathOr(null, ["overall"], this.hope_to_successful_performance);
    },
    reportDateJalali() {
      return pathOr(null, ["report_date", "jalali"], this.reportData);
    },
    reportExecuteCode() {
      return pathOr("", ["person_center_execute_code"], this.reportData);
    },
    reportExecuteName() {
      const personName = pathOr(null, ["person", "name"], this.reportData);
      const personFamily = pathOr(null, ["person", "family"], this.reportData);
      return personName || personFamily ? `${personName} ${personFamily}` : "";
    },
    reportCaption() {
      return pathOr("", ["report_caption"], this.reportData);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    generateApiUrl,
    generateData(data) {
      this.competencies = pathOr([], ["competencies_evaluated"], data);
      this.exercises = pathOr(null, ["0", "exercise"], this.competencies);
      this.hope_to_successful_performance = pathOr(
        null,
        ["hope_to_successful_performance"],
        data
      );
      this.effect_of_position_on_success = pathOr(
        [],
        ["effect_of_position_on_success"],
        data
      );
      this.reportData = pathOr(null, ["report"], data);
      this.logo = pathOr(this.$config.images.tinyLogo, ["logo"], data);
    },
    generateTdColor(key = 0) {
      const colors = [
        "bg-empty",
        "red-two",
        "red-one",
        "blue-one",
        "green-one",
        "green-two",
      ];
      return pathOr("", [key], colors);
    },
    async fetchData() {
      try {
        this.loading = true;
        const url = generateApiUrl(
          ["kanoon", "analitical_report"],
          [this.resourceCode, this.parvandehCode]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.hasData = !!data;
        this.generateData(data);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    onProgress() {},
    print() {
      window.print();
    },
  },
};
</script>
<style lang="scss" scoped>
.first-page,
.second-page {
  * {
    background-color: transparent !important;
  }
  background-image: url("/img/shared/report-bg/analitical-1.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  min-width: 100%;
  min-height: 1380px;
  &__logo {
    position: absolute;
    top: 50px;
    left: 90px;
  }
  &__title {
    background-color: transparent !important;
    width: 100%;
    position: absolute;
    top: 20%;
    right: calc(100% - 35rem);
    font-size: calc(100% + 1rem);
    color: #e2a63d;
  }
  &__footer {
    position: absolute;
    bottom: 35px;
    width: 100%;
    background-color: transparent !important;
    &-item {
      background-color: transparent !important;
      color: #fff;
      font-size: 1rem;
      text-align: center;
    }
  }
}
.second-page {
  background-image: url("/img/shared/report-bg/analitical-2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  &__title {
    position: absolute;
    background-color: transparent !important;
    left: 15px;
    top: 80px;
    width: auto;
    text-align: left;
    &-top,
    &-bottom {
      background-color: transparent !important;
      color: #e2a63d;
      font-size: 1rem;
      font-weight: bold;
    }
  }
}
.bg_white {
  background-color: #fff !important;
}
.header-bar {
  background-color: #966717 !important;
  color: #fff;
  font-size: 1.5rem;
}
.mt-200 {
  margin-top: 200px !important;
}
.bg-blue-light {
  background-color: #bdd7ee !important;
}
.bg-empty {
  background-color: #d9d9d9 !important;
}
.blue-one {
  background-color: #8ea9db !important;
}
.blue-two {
  background-color: #2f75b5 !important;
}
.green-one {
  background-color: #a9d08e !important;
}
.green-two {
  background-color: #00b050 !important;
}
.red-one {
  background-color: #ff6e6e !important;
}
.red-two {
  background-color: #ff0000 !important;
}
</style>
